import turfQualityApi, {
  ICreateTurfQualityPayload,
} from '@/api/config/turfQualityApi'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'

async function createTurfQuality(
  payload: ICreateTurfQualityPayload,
): Promise<void> {
  await turfQualityApi.create(payload)
}

const useAddTurfQuality = () => {
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation(
    (payload: ICreateTurfQualityPayload) => createTurfQuality(payload),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([queryKeys.turfQuality])

        toast.success('Add New Turf Quality Success')

        closeSidebar()
      },
      onError: (error: any) => {
        toast.error(error?.message)
      },
    },
  )
}

export default useAddTurfQuality
